module.exports = __webpack_public_path__ + "static/media/newsletter-icon.24588f28.svg";